<template>
  <div class="w-full min-h-screen flex flex-col">
      <MainNav />
      <section class="w-full relative">
    <!-- Video Background -->
    <div class="relative h-[800px] overflow-hidden">
        <video 
            autoplay 
            loop 
            muted 
            playsinline 
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 min-w-full min-h-full object-cover"
        >
            <source src="/video/83islands-tours.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </div>
        
        <!-- Text Overlay -->
        <div class="mx-auto absolute mt-36 inset-0 z-20 w-full p-4 lg:p-36 flex flex-col items-center lg:items-start">
            <h1 class="text-white font-maax text-4xl uppercase lg:text-6xl font-bold text-center lg:text-left max-w-3xl leading-tight drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)]">
              83 Islands Tour & Tasting - The Highest Rated Tour in Port Vila
          </h1>

          <!-- Buttons -->
      <div class="flex flex-col sm:flex-row gap-4 mt-8 lg:mt-12">
        <a 
          href="#calendar-section" 
          class="font-maax px-8 py-3 uppercase font-bold transition-all rounded-lg drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] border-2 text-white hover:bg-white hover:text-black hover:border-white text-center sm:text-left"
        >
          Book Tour
      </a>
        <router-link 
          to="/contact?from=event-booking#event-booking" 
          class="font-maax px-8 py-3 uppercase font-bold transition-all rounded-lg drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] border-2 text-white hover:bg-white hover:text-black hover:border-white text-center sm:text-left"
        >
          Event Enquiry
        </router-link>

        <!-- <router-link to="/Home" class="font-maax px-8 py-3 uppercase font-bold transition-all rounded-full drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] border-2 hover:border-white hover:text-white" style="border-image: linear-gradient(45deg, #F6D993, #A87539 80%) 1; background: -webkit-linear-gradient(45deg, #F6D993, #A87539 80%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; transition: border-image 0.3s ease, -webkit-text-fill-color 0.3s ease;">
      Discover
    </router-link> -->
       
      </div>
        </div>

<!--  Double Wave -->
            <div class="absolute -bottom-1 left-0 right-0 w-full overflow-hidden">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="w-full h-20 text-white">
                    <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                          fill="currentColor" class="opacity-25"/>
                    <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                          fill="currentColor"/>
                </svg>
            </div>
        </section>

       

        <main class="flex-grow w-full bg-white">
        <div class="container mx-auto p-4">
    <!-- Create a flex container for the split layout -->
    <div class="flex flex-col gap-8">
      <!-- Main content - full width -->
      <div class="w-full">
        <h2 class="text-4xl font-maax font-bold uppercase text-black pb-4">Join Us for an Unforgettable Experience.</h2>

        <p class="font-maax text-black text-2xl pb-8">Step into the heart of 83 Islands Distillery and immerse yourself in the craft, tradition, and untamed beauty of Vanuatu. From guided tastings to exclusive events, experience our world-class rums in the best-looking bar in Port Vila—a space designed to reflect the raw elegance of the islands.</p>

        <p class="font-maax text-black text-2xl pb-8">
          Go beyond the bottle and explore the flavors, stories, and rhythms that define our spirit. Whether you're a seasoned enthusiast or new to rum, an unforgettable journey awaits.
        </p>
        <p class="font-maax text-black text-2xl">
        Book your experience today and raise a glass to the extraordinary.
        </p>
      </div>

      <!-- Important Information Bar - full width -->
      <div class="w-full mt-8">
        <div class="bg-black p-8 rounded-lg text-white">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <!-- Date & Status -->
            <div class="border-b md:border-b-0 md:border-r border-gray-700 pb-4 md:pb-0 md:pr-6">
              <div class="text-sm text-gray-400">Today's Date</div>
              <div class="text-2xl font-bold mb-4">
                {{ format(new Date(), 'MMMM d, yyyy') }}
              </div>
              <div>
                <div class="flex items-center">
                  <div 
                    class="h-3 w-3 rounded-full mr-2 flex-shrink-0"
                    :class="isOpenToday ? 'bg-green-500' : 'bg-red-500'"
                  ></div>
                  <div 
                    class="text-lg font-semibold"
                    :class="isOpenToday ? 'text-green-500' : 'text-red-500'"
                  >
                    {{ isOpenToday ? 'Open' : 'Closed' }}
                  </div>
                </div>
                <div class="text-xs text-gray-400 mt-1 whitespace-pre-line ml-5">
                  {{ isOpenToday ? todaysOperatingHours : closedReason }}
                </div>
              </div>
            </div>

            <!-- Tour Options -->
            <div class="border-b md:border-b-0 md:border-r border-gray-700 pb-4 md:pb-0 md:pr-6">
              <h4 class="text-lg font-semibold text-gold mb-3">Tour Options</h4>
              <div class="space-y-2 text-gray-400">
                <p class="text-white font-bold ">Distillery Experience: 4,000 VT</p>
                <p class="text-xs text-gray-400">Guided journey through our artisanal rum-making process, from fresh sugarcane to the final spirit, with an exclusive behind-the-scenes look at fermentation, distillation, and barrel aging.</p>
                <p class="text-white font-bold">Cellar Door Tasting: 2,500 VT</p>
                <p class="text-xs text-gray-400"> Curated tasting of our premium rums, each sip revealing the island's rich terroir and craftsmanship.</p>
              </div>
            </div>

            <!-- Important Info -->
            <div class="border-b md:border-b-0 md:border-r border-gray-700 pb-4 md:pb-0 md:pr-6">
              <h4 class="text-lg font-semibold text-gold mb-3">Important Info</h4>
              <ul class="space-y-2 text-sm">
                <li class="text-gray-300">• Maximum 16 people per group</li>
                <li class="text-gray-300">• Free cancellation</li>
                <li class="text-gray-300">• Accessibility access available</li>
                <li class="text-gray-300">• French tours subject to availability</li>
                <li class="text-gray-300">• 18+ for tasting. Non-alcoholic drinks available</li>
                <li class="text-gray-300">• Closed on Sundays and Public Holidays</li>
              </ul>
            </div>

            <!-- Safety Notice -->
            <div>
              <h4 class="text-lg font-semibold text-red-400 mb-3">Safety Notice</h4>
              <ul class="space-y-2 text-sm">
                <li class="text-gray-300">• Active working distillery</li>
                <li class="text-gray-300">• Hazards to be expected</li>
                <li class="text-gray-300 font-bold">• No smoking on site</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Calendar and Tour Picker Container -->
  <div class="relative">
    <!-- Scroll target with offset -->
    <div id="calendar-section" class="absolute" style="top: -50px"></div>
    
    <!-- Actual calendar content -->
    <div class="container mx-auto w-full flex flex-col lg:flex-row gap-8 p-4">
      <!-- Calendar Section -->
      <section class="relative bg-white w-full lg:w-3/5">
        <div class="relative mx-auto h-full py-8 sm:py-12 lg:px-8 lg:py-12">
          <div class="h-full w-full">
            <div class="h-full flex flex-col">
              <!-- Temporary Banner for September 13th Closure -->
              <div v-if="showSeptember13Banner" class="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm text-amber-800 font-medium">
                      83 Islands Distillery will be closed on Saturday, September 13th for a community event
                    </p>
                  </div>
                </div>
              </div>
              
              <h2 class="text-2xl font-semibold leading-6 text-gray-900">Select a Date</h2>
              <p class="text-sm mb-4">Book up to 3 months in advance</p>
              <div class="flex items-center">
                <h2 class="flex-auto text-base font-semibold leading-6 text-gray-900">
                  <time :datetime="currentMonth">{{ formattedCurrentMonth }}</time>
                </h2>
                <button 
                  type="button" 
                  class="-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 bg-transparent" 
                  @click="prevMonth"
                  :disabled="isBefore(startOfMonth(subMonths(currentMonth, 1)), startOfMonth(today))"
                >
                  <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
                  <span class="">Previous month</span>
                </button>
                <button 
                  type="button" 
                  class="-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 bg-transparent" 
                  @click="nextMonth"
                  :disabled="isAfter(startOfMonth(addMonths(currentMonth, 1)), maxFutureMonth)"
                >
                  <span class="">Next month</span>
                  <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
              <div class="mt-10 grid grid-cols-7 text-center text-2xl leading-6 text-gray-500">
                <div>M</div>
                <div>T</div>
                <div>W</div>
                <div>T</div>
                <div>F</div>
                <div>S</div>
                <div>S</div>
              </div>
              <div class="mt-8 grid grid-cols-7 text-xl">
                <div 
                  v-for="(day, dayIdx) in days" 
                  :key="day.date" 
                  :class="[
                    dayIdx > 6 && 'border-t border-gray-200',
                    'py-4'
                  ]"
                >
                  <button
                    v-if="!day.isEmpty"
                    type="button"
                    :class="[
                      'mx-auto flex flex-col h-12 w-12 items-center justify-center rounded-full focus:outline-none',
                      // Opened Sunday - green background
                      day.isSundayOpen ? 'bg-green-100 ring-2 ring-green-400' :
                      // Holiday or closed Sunday - red background
                      (day.holiday || getDay(parseISO(day.date)) === 0) ? 'bg-red-100' : 'bg-transparent',
                      day.isPast ? 'text-gray-400 cursor-not-allowed' :
                      day.isSelected ? '!bg-gold !text-black' :
                      day.isToday ? '!bg-gray-400 !text-black' :
                      day.isCurrentMonth ? 'text-gray-900' : 'text-gray-400',
                      // Allow hover on opened Sundays
                      !day.isPast && !day.isSelected && !day.holiday && (getDay(parseISO(day.date)) !== 0 || day.isSundayOpen) && 'hover:bg-gray-100',
                      (day.isSelected || day.isToday) && 'font-semibold'
                    ]"
                    @click="!day.isPast && !day.holiday && (getDay(parseISO(day.date)) !== 0 || day.isSundayOpen) && selectDate(day.date)"
                    :disabled="day.isPast || day.holiday || (getDay(parseISO(day.date)) === 0 && !day.isSundayOpen)"
                    :title="day.holiday || (getDay(parseISO(day.date)) === 0 && !day.isSundayOpen ? 'Closed on Sundays' : day.isSundayOpen ? day.sundayOpenName : '')"
                  >
                    <time v-if="!day.isEmpty" :datetime="day.date">
                      {{ day.isEmpty ? '' : parseInt(day.date.split('-')[2]) }}
                    </time>
                  </button>
                </div>
              </div>

              <!-- Upcoming Holidays Section -->
              <div class="hidden lg:block mt-8 border-t border-gray-200 pt-8">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <!-- Holidays Section -->
                  <div>
                    <h3 class="text-lg font-semibold text-gray-900 mb-4">Upcoming Holidays</h3>
                    <div class="space-y-2">
                      <div v-if="holidays.length === 0" class="text-gray-500">
                        Loading holidays...
                      </div>
                      <div 
                        v-for="holiday in upcomingHolidays" 
                        :key="holiday.date" 
                        class="flex items-center space-x-4 py-2"
                      >
                        <div class="flex-shrink-0 w-24">
                          <span class="text-sm font-medium text-gray-500">
                            {{ format(parseISO(holiday.date), 'MMM dd') }}
                          </span>
                        </div>
                        <div class="flex-grow">
                          <span class="text-sm text-gray-900">{{ holiday.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Events Section -->
                  <div>
                    <h3 class="text-lg font-semibold text-gray-900 mb-4">Events</h3>
                    <div class="space-y-2">
                      <div 
                        v-for="event in upcoming83IslandsNights" 
                        :key="event.date" 
                        class="flex items-center space-x-4 py-2"
                      >
                        <div class="flex-shrink-0 w-24">
                          <span class="text-sm font-medium text-gray-500">
                            {{ format(parseISO(event.date), 'MMM dd') }}
                          </span>
                        </div>
                        <div class="flex-grow">
                          <span class="text-sm text-gray-900">83 Islands Nights</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Tour Picker Section -->
      <section id="tour-picker-section" class="relative w-full lg:w-2/5">
        <div class="bg-black p-8 rounded-lg text-white">
          <div class="border-b border-gray-700 pb-4 mb-4">
            <h2 class="text-2xl font-semibold leading-6 text-gray-100">Available Tours for {{ formattedSelectedDate }}</h2>
            <p v-if="isWeekend" class="text-sm text-gold mt-2">
              On Saturday, tours are only available from 12 PM onwards.
            </p>
            <p v-if="isJuly28th2025" class="text-sm text-gold mt-2">
              On July 28th, 2025, tours are only available from 12 PM onwards due to a private event.
            </p>
            <p class="text-sm pt-2 leading-6 text-gray-400">Click on a time to proceed with booking</p>
          </div>

          <!-- Add Tour Type Filter -->
          <div class="flex space-x-2 mb-4">
            <button
              v-for="type in tourTypes"
              :key="type"
              @click="selectedTourType = type"
              :class="[
                'px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300',
                selectedTourType === type
                  ? 'bg-gold text-black'
                  : 'bg-gray-800 text-white hover:bg-gray-700'
              ]"
            >
              {{ type }}
            </button>
          </div>

          <div v-if="(isSunday && !isSundayOpen) || isSelectedDateHoliday" class="text-center text-red-400 mt-4">
            Sorry, we are closed on Sundays and public holidays.
          </div>

          <!-- Sunday Open Notice -->
          <div v-else-if="isSundayOpen && sundayOpenEntry" class="mb-4 p-3 bg-green-900 bg-opacity-30 border border-green-600 rounded-lg">
            <div class="flex items-center text-green-400">
              <span class="mr-2">🔓</span>
              <span class="font-medium">Special Sunday Opening: {{ sundayOpenEntry.name }}</span>
            </div>
            <p v-if="sundayOpenEntry.openingTime" class="text-sm text-green-300 mt-1 ml-6">
              Opens at {{ sundayOpenEntry.openingTime }}
            </p>
          </div>

          <ol v-if="!((isSunday && !isSundayOpen) || isSelectedDateHoliday)" class="mt-4 space-y-4 text-sm leading-6 text-gray-400">
            <li v-for="tour in filteredToursByType.filter(tour => !isPastTime(tour.time))" 
                :key="tour.id" 
                @click="tour.isAvailable && selectTourTime(tour.time, tour.id)"
                :class="[
                  'group rounded-xl px-4 py-2 border-2 transition-all duration-300',
                  tour.type === 'Tasting Only' ? 'bg-gray-900' : 'bg-gray-800',
                  tour.isAvailable 
                    ? 'hover:bg-opacity-75 hover:border-gold border-transparent cursor-pointer' 
                    : 'opacity-50 border-transparent cursor-not-allowed'
                ]"
            >
              <div class="flex items-center space-x-4">
                <div class="flex-auto">
                  <p class="mt-0.5 text-xs" :class="getAvailabilityClass(tour)">
                    {{ getAvailabilityText(tour) }}
                  </p>
                  <p class="mt-0.5 text-xl font-bold text-white flex items-center gap-2">
                    {{ tour.time }} - {{ tour.type }}
                    <span v-if="tour.hasWarning" class="text-yellow-400" title="Warning">⚠️</span>
                  </p>
                  <p class="text-sm text-gray-400">
                    {{ tour.type === 'Tour and Tasting' ? '4,000 VT PP' : '2,500 VT PP' }} -
                    {{ tour.type === 'Tour and Tasting' ? 'Approx 1 hour duration' : 'Approx 30 min duration' }}
                  </p>
                  <p v-if="tour.hasWarning && tour.warningMessage" class="mt-2 text-sm text-yellow-400 italic bg-yellow-900 bg-opacity-20 p-2 rounded border border-yellow-700">
                    ⚠️ {{ tour.warningMessage }}
                  </p>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </section>
    </div>
  </div>


  </main> 
      <Footer class="relative" />
    </div>
  </template>
  
  <script setup>
  import { ref, watch, onMounted, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/solid'
  import { 
    addMonths, 
    eachDayOfInterval, 
    endOfMonth, 
    format, 
    startOfMonth, 
    subMonths, 
    isValid, 
    isBefore, 
    startOfDay, 
    isAfter, 
    getDay,
    parseISO,
    isToday,
    addDays,
    set
  } from 'date-fns'
  import { formatInTimeZone } from 'date-fns-tz'
  import axios from 'axios'
  import Footer from '../components/Footer.vue'
  import MainNav from '../components/MainNav.vue'
  import { useFacebookPixel } from '../composables/useFacebookPixel'
  import { useStructuredData } from '../composables/useStructuredData'

  const router = useRouter()
  const route = useRoute()

  // Initialize Facebook Pixel
  const { initFacebookPixel, updateConsent, trackViewTours, trackSelectTourDateTime } = useFacebookPixel()
  
  // Initialize Structured Data
  const { injectStructuredData } = useStructuredData()

  // Initialize date values
  const today = startOfDay(new Date())
  const currentMonth = ref(today)
  const selectedDate = ref(today)
  const maxFutureMonth = addMonths(today, 3)
  const days = ref([])
  const showHeader = ref(true)
  const tours = ref([])
  const todayBookingsCount = ref(0)
  const selectedTourId = ref(null)
  const holidays = ref([])
  const selectedTourType = ref('All Tours')
  const tourTypes = ['All Tours', 'Tour and Tasting', 'Cellar Door Tasting']
  const bookings = ref({})
  const MAX_CAPACITY = 16
  const TIMEZONE = 'Pacific/Efate'

  // Create an axios instance with base configuration
  const api = axios.create({
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    timeout: 10000
  })

  // Safe date formatting function
  const safeFormat = (date, formatString) => {
    try {
      if (!date) return ''
      const validDate = date instanceof Date ? date : new Date(date)
      return isValid(validDate) ? format(validDate, formatString) : ''
    } catch (error) {
      console.error('Date formatting error:', error)
      return ''
    }
  }

  // Computed properties
  const formattedCurrentMonth = computed(() => {
    return safeFormat(currentMonth.value, 'MMMM yyyy')
  })

  const formattedSelectedDate = computed(() => {
    return safeFormat(selectedDate.value, 'MMMM dd, yyyy')
  })

  const isSunday = computed(() => {
    return getDay(selectedDate.value) === 0  // 0 is Sunday
  })

  const isWeekend = computed(() => {
    const day = getDay(selectedDate.value)
    return day === 6  // Only Saturday is treated as weekend for tour times
  })

  // Add computed property for July 28th, 2025 restriction
  const isJuly28th2025 = computed(() => {
    const selectedDateStr = format(selectedDate.value, 'yyyy-MM-dd')
    return selectedDateStr === '2025-07-28'
  })

  const isPastTime = (time) => {
    if (!isToday(selectedDate.value)) return false
    
    const now = new Date()
    const [timeStr, period] = time.split(' ')
    let [hours, minutes] = timeStr.split(':')
    
    // Convert to 24 hour format
    hours = parseInt(hours)
    if (period === 'PM' && hours !== 12) hours += 12
    if (period === 'AM' && hours === 12) hours = 0
    
    // Add 30 minutes buffer before tour time
    const tourTime = new Date()
    tourTime.setHours(hours, parseInt(minutes || 0) - 30, 0)
    
    return isBefore(tourTime, now)
  }

  const getAvailabilityClass = (tour) => {
    if (!tour.isAvailable) return 'text-red-400'
    
    const bookedGuests = getBookedGuestsForTour(tour)
    if (bookedGuests >= 12) return 'text-orange-400'
    if (bookedGuests >= 8) return 'text-yellow-400'
    return 'text-green-600'
  }

  const getBookedGuestsForTour = (tour) => {
    const dateStr = format(selectedDate.value, 'yyyy-MM-dd')
    const localTime = convertToLocalTime(tour.time, dateStr)
    const formattedTime = formatTimeForDisplay(localTime)
    
    const tourBookings = bookings.value[dateStr]?.[formattedTime]?.[tour.type]
    return typeof tourBookings === 'object' ? tourBookings?.count || 0 : tourBookings || 0
  }

  const getAvailabilityText = (tour) => {
    if (!tour.isAvailable) return 'Unavailable'
    
    const dateStr = format(selectedDate.value, 'yyyy-MM-dd')
    const localTime = convertToLocalTime(tour.time, dateStr)
    const formattedTime = formatTimeForDisplay(localTime)
    const tourBookings = bookings.value[dateStr]?.[formattedTime]?.[tour.type]
    const bookedGuests = typeof tourBookings === 'object' ? tourBookings?.count || 0 : tourBookings || 0
    const tourLanguage = typeof tourBookings === 'object' ? tourBookings?.language : null

    // Check if the time is between 11 AM and 2 PM
    const [time, period] = tour.time.split(' ')
    const hour = parseInt(time)
    const is11to2 = (period === 'AM' && hour === 12) || 
                   (period === 'PM' && (hour === 12 || hour === 1 || hour === 1))

    let availabilityText = ''
    if (bookedGuests >= 12) {
      availabilityText = 'Few places left'
    } else if (bookedGuests >= 8) {
      availabilityText = 'Some places left'
    } else {
      // Set default language availability based on time
      availabilityText = is11to2 ? 
        'Available in English' : 
        'Available in English or French'
    }

    // Override with actual booking language if tour is booked
    if (tourLanguage) {
      availabilityText = `In ${tourLanguage}`
    }

    return availabilityText
  }

  // Check if selected date is an unlocked Sunday
  const sundayOpenEntry = computed(() => {
    const selectedDateStr = format(selectedDate.value, 'yyyy-MM-dd')
    return holidays.value.find(holiday =>
      holiday.date === selectedDateStr &&
      holiday.actionType === 'sunday_open'
    )
  })

  const isSundayOpen = computed(() => {
    return !!sundayOpenEntry.value
  })

  const filteredTours = computed(() => {
    // If it's Sunday or a holiday (not warning), return empty array
    const selectedDateStr = format(selectedDate.value, 'yyyy-MM-dd')

    // Check if this is a full-day blocked holiday (not warning, sunday_open or schedule_change).
    // Blocks with specific time slots keep the day open; those slots are filtered out below.
    const isHoliday = holidays.value.some(holiday =>
      holiday.date === selectedDateStr &&
      holiday.actionType !== 'warning' &&
      holiday.actionType !== 'sunday_open' &&
      holiday.actionType !== 'schedule_change' &&
      (!holiday.blockedTimeSlots || holiday.blockedTimeSlots.length === 0)
    )

    // If it's Sunday, check if it's been opened
    if (isSunday.value) {
      if (!isSundayOpen.value) {
        return [] // Sunday is closed by default
      }
      // Sunday is open - filter tours to only show available time slots
      const openEntry = sundayOpenEntry.value
      let availableTours = tours.value.filter(tour =>
        openEntry.availableTimeSlots && openEntry.availableTimeSlots.includes(tour.time)
      )

      // Filter out past times and fully booked tours, add warning info for Sunday
      return availableTours.map(tour => {
        const bookedGuests = getBookedGuestsForTour(tour)

        // Check for warnings on this Sunday (embedded in sunday_open entry)
        const hasWarning = openEntry.warningTimeSlots &&
          openEntry.warningTimeSlots.includes(tour.time)

        return {
          ...tour,
          isAvailable: !isPastTime(tour.time) && bookedGuests < MAX_CAPACITY,
          hasWarning,
          warningMessage: hasWarning ? openEntry.warningMessage : null
        }
      })
    }

    if (isHoliday) {
      return []
    }

    let availableTours = tours.value

    // Remove time slots blocked by partial-day blocks (e.g. private events)
    const blockedSlots = holidays.value
      .filter(h =>
        h.date === selectedDateStr &&
        h.actionType !== 'warning' &&
        h.actionType !== 'sunday_open' &&
        h.actionType !== 'schedule_change' &&
        Array.isArray(h.blockedTimeSlots) &&
        h.blockedTimeSlots.length > 0
      )
      .flatMap(h => h.blockedTimeSlots)
    if (blockedSlots.length > 0) {
      availableTours = availableTours.filter(tour => !blockedSlots.includes(tour.time))
    }

    // Schedule changes restrict the day to their available time slots
    const scheduleChange = holidays.value.find(h =>
      h.date === selectedDateStr &&
      h.actionType === 'schedule_change' &&
      Array.isArray(h.availableTimeSlots) &&
      h.availableTimeSlots.length > 0
    )
    if (scheduleChange) {
      availableTours = availableTours.filter(tour => scheduleChange.availableTimeSlots.includes(tour.time))
    }

    // Weekend (Saturday) logic
    if (isWeekend.value) {
      availableTours = availableTours.filter(tour => {
        const [time, period] = tour.time.split(' ')
        const hour = parseInt(time)
        return period === 'PM' || (period === 'AM' && hour === 12)
      })
    }

    // July 28th, 2025 morning restriction - block public bookings before 12:00 PM
    if (isJuly28th2025.value) {
      availableTours = availableTours.filter(tour => {
        const [time, period] = tour.time.split(' ')
        const hour = parseInt(time)
        return period === 'PM' || (period === 'AM' && hour === 12)
      })
    }

    // Filter out past times and fully booked tours, add warning info
    return availableTours.map(tour => {
      const bookedGuests = getBookedGuestsForTour(tour)

      // Check for warnings on this date/time
      const warningHoliday = holidays.value.find(h =>
        h.date === selectedDateStr &&
        h.actionType === 'warning' &&
        h.warningTimeSlots &&
        h.warningTimeSlots.includes(tour.time)
      )

      return {
        ...tour,
        isAvailable: !isPastTime(tour.time) && bookedGuests < MAX_CAPACITY,
        hasWarning: !!warningHoliday,
        warningMessage: warningHoliday?.warningMessage || null
      }
    })
  })

  const filteredToursByType = computed(() => {
    if (selectedTourType.value === 'All Tours') {
      return filteredTours.value
    }
    return filteredTours.value.filter(tour => tour.type === selectedTourType.value)
  })

  // Generate calendar days
  const generateDays = (month) => {
    try {
      const monthDate = new Date(month)
      if (!isValid(monthDate)) {
        console.error('Invalid month provided to generateDays')
        return
      }

      const start = startOfMonth(monthDate)
      const end = endOfMonth(monthDate)
      
      let firstDayOfWeek = getDay(start)
      firstDayOfWeek = firstDayOfWeek === 0 ? 7 : firstDayOfWeek
      const offset = firstDayOfWeek - 1
      
      // Add empty days at the start with unique keys
      const emptyDays = Array(offset).fill(null).map((_, index) => ({
        date: `empty-${index}`, // Unique key for empty days
        isCurrentMonth: false,
        isToday: false,
        isSelected: false,
        isPast: false,
        isEmpty: true // New flag to identify empty days
      }))
      
      // Generate current month days
      const daysInMonth = eachDayOfInterval({ start, end }).map(day => {
        const dateStr = safeFormat(day, 'yyyy-MM-dd')
        // Only mark as holiday if it's not a warning, sunday_open or schedule_change.
        // Blocks with specific time slots only disable those slots, not the whole day.
        const holiday = holidays.value.find(h =>
          h.date === dateStr &&
          h.actionType !== 'warning' &&
          h.actionType !== 'sunday_open' &&
          h.actionType !== 'schedule_change' &&
          (!h.blockedTimeSlots || h.blockedTimeSlots.length === 0)
        )

        // Check if this is an opened Sunday
        const sundayOpen = holidays.value.find(h =>
          h.date === dateStr &&
          h.actionType === 'sunday_open'
        )

        return {
          date: dateStr,
          isCurrentMonth: true,
          isToday: safeFormat(day, 'yyyy-MM-dd') === safeFormat(today, 'yyyy-MM-dd'),
          isSelected: safeFormat(day, 'yyyy-MM-dd') === safeFormat(selectedDate.value, 'yyyy-MM-dd'),
          isPast: isBefore(day, today),
          isEmpty: false,
          holiday: holiday ? holiday.name : null,
          isSundayOpen: !!sundayOpen,
          sundayOpenName: sundayOpen ? sundayOpen.name : null
        }
      })
      
      days.value = [...emptyDays, ...daysInMonth]
    } catch (error) {
      console.error('Error generating days:', error)
      days.value = []
    }
  }

  // Navigation functions
  const prevMonth = () => {
    try {
      const newMonth = subMonths(currentMonth.value, 1)
      if (!isBefore(startOfMonth(newMonth), startOfMonth(today))) {
        currentMonth.value = newMonth
      }
    } catch (error) {
      console.error('Error navigating to previous month:', error)
    }
  }

  const nextMonth = () => {
    try {
      const newMonth = addMonths(currentMonth.value, 1)
      if (!isAfter(startOfMonth(newMonth), maxFutureMonth)) {
        currentMonth.value = newMonth
      }
    } catch (error) {
      console.error('Error navigating to next month:', error)
    }
  }

  const selectDate = (dateString) => {
    try {
      const date = parseISO(dateString)
      if (isValid(date)) {
        selectedDate.value = date
        generateDays(currentMonth.value)
      }
    } catch (error) {
      console.error('Error selecting date:', error)
    }
  }

  const fetchTodayBookingsCount = async () => {
    try {
      todayBookingsCount.value = 0
    } catch (error) {
      console.error('Error fetching bookings count:', error)
      todayBookingsCount.value = 0
    }
  }

  const fetchHolidays = async () => {
    try {
      // Calculate timeMin and timeMax for the request query parameters
      const timeMin = new Date().toISOString();
      // Fetch holidays for the next 3 months (consistent with previous logic)
      const timeMax = addMonths(new Date(), 3).toISOString();

      // Fetch both Google Calendar holidays and custom holidays in parallel
      const [googleHolidaysResponse, customHolidaysResponse] = await Promise.all([
        api.get('/api/holidays', {
          params: {
            timeMin,
            timeMax
          }
        }),
        api.get('/api/admin-holidays')
      ]);

      let googleHolidays = [];
      let fetchedCustomHolidays = [];

      // Process Google Calendar holidays
      if (googleHolidaysResponse.data && Array.isArray(googleHolidaysResponse.data.items)) {
        googleHolidays = googleHolidaysResponse.data.items.map(event => ({
          date: format(new Date(event.start.date || event.start.dateTime), 'yyyy-MM-dd'),
          name: event.summary
        }));
      }

      // Process custom holidays from admin API (both blocks and warnings)
      if (customHolidaysResponse.data && customHolidaysResponse.data.success) {
        fetchedCustomHolidays = customHolidaysResponse.data.holidays.map(holiday => ({
          date: holiday.date,
          name: holiday.name,
          blockedTimeSlots: holiday.blockedTimeSlots, // Include blocked time slots info
          actionType: holiday.actionType || 'block', // 'block', 'warning', or 'sunday_open'
          warningTimeSlots: holiday.warningTimeSlots, // Times to show warning
          warningMessage: holiday.warningMessage, // Warning message text
          cruiseShips: holiday.cruiseShips,
          totalEstimatedPassengers: holiday.totalEstimatedPassengers,
          // Sunday opening fields
          availableTimeSlots: holiday.availableTimeSlots, // Available time slots for opened Sundays
          openingTime: holiday.openingTime // Opening time for Sunday openings
        }));
      }

      // Merge all holidays (Google Calendar + Custom + Hardcoded legacy)
      holidays.value = [...googleHolidays, ...fetchedCustomHolidays, ...customHolidays];

      // Regenerate calendar days after holidays are updated
      generateDays(currentMonth.value);

    } catch (error) {
      console.error('Error fetching holidays:', {
          message: error.message,
          code: error.code,
          status: error.response?.status,
          response: error.response?.data,
          requestUrl: error.config?.url
      });
      // Fallback to hardcoded holidays if API fails
      holidays.value = [...customHolidays];
      generateDays(currentMonth.value);
    }
  }

  // Update the convertToLocalTime function
  const convertToLocalTime = (time, date) => {
    const [hourStr, period] = time.split(' ')
    let [hours, minutes] = hourStr.split(':')
    hours = parseInt(hours)
    
    // Convert to 24-hour format
    if (period === 'PM' && hours !== 12) hours += 12
    if (period === 'AM' && hours === 12) hours = 0
    
    // Create a date object with the tour date and time
    const dateObj = new Date(date)
    dateObj.setHours(hours, parseInt(minutes || 0), 0, 0)
    
    // Convert to Vanuatu time using formatInTimeZone
    return new Date(formatInTimeZone(dateObj, TIMEZONE, "yyyy-MM-dd'T'HH:mm:ssXXX"))
  }

  // Update the formatTimeForDisplay function
  const formatTimeForDisplay = (date) => {
    return formatInTimeZone(date, TIMEZONE, 'h:mm a')
  }

  // Update the fetchBookings function
  const fetchBookings = async () => {
    try {
      const dateStr = format(selectedDate.value, 'yyyy-MM-dd')
      console.log('Fetching bookings for date:', dateStr)
      
      const response = await api.get('/api/bookings', {
        params: { date: dateStr }
      })
      
      // Normalize the bookings data
      const normalizedBookings = {}
      if (response.data[dateStr]) {
        Object.entries(response.data[dateStr]).forEach(([time, bookingData]) => {
          // Convert the time to a consistent format
          const localTime = convertToLocalTime(time, dateStr)
          const formattedTime = formatTimeForDisplay(localTime)
          
          normalizedBookings[formattedTime] = bookingData
        })
      }
      
      bookings.value = { [dateStr]: normalizedBookings }
      
      console.log('Bookings fetched successfully:', {
        date: dateStr,
        bookingsCount: Object.keys(normalizedBookings).length,
        timestamp: new Date().toISOString(),
        data: response.data
      })
    } catch (error) {
      console.error('Error fetching bookings:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        timestamp: new Date().toISOString()
      })
      bookings.value = { [format(selectedDate.value, 'yyyy-MM-dd')]: {} }
    }
  }

  // Watch for month changes
  watch(currentMonth, (newVal) => {
    if (newVal) {
      generateDays(newVal)
    }
  }, { immediate: true })

  // Update the watch section to fetch bookings when the date changes
  watch(selectedDate, () => {
    fetchBookings()
  })

  // Add these near the top of the script setup, after imports
  const testDbConnection = async () => {
    try {
      console.log('Testing MongoDB connection...')
      const response = await api.get('/api/db-test')
      console.log('MongoDB Connection Test Result:', {
        ...response.data,
        timestamp: new Date().toISOString()
      })
      return response.data
    } catch (error) {
      const errorDetails = {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        timestamp: new Date().toISOString()
      }
      console.error('MongoDB Connection Test Failed:', errorDetails)
      throw error
    }
  }

  // Update the logEnvironmentInfo function
  const logEnvironmentInfo = () => {
    // Only log in development
    if (import.meta.env.DEV) {
      console.log('Environment:', {
        MODE: import.meta.env.MODE,
        PROD: import.meta.env.PROD,
        DEV: import.meta.env.DEV,
        API_URL: import.meta.env.API_URL,
      })

      // Only try to parse URL if it exists
      if (import.meta.env.API_URL) {
        try {
          const apiUrl = new URL(import.meta.env.API_URL)
          console.log('Serverless API Port:', apiUrl.port)
          console.log('Full API URL:', apiUrl.toString())
        } catch (error) {
          console.warn('API URL not set or invalid:', import.meta.env.API_URL)
        }
      }
    }
  }

  // Add this function to check if we're past working hours
  const isPastWorkingHours = () => {
    const now = new Date()
    const endOfWorkDay = set(now, { hours: 17, minutes: 0, seconds: 0 })
    return isAfter(now, endOfWorkDay)
  }

  // Update the onMounted section
  onMounted(async () => {
    try {
      // Initialize Facebook Pixel with implicit consent
      initFacebookPixel();
      updateConsent(true);
      
      // Track page view
      trackViewTours();
      
      // Inject structured data for SEO
      injectStructuredData();
      
      // Log environment info
      logEnvironmentInfo()

      // Check for coupon in query parameters
      if (route.query.coupon) {
        console.log('Coupon code found:', route.query.coupon)
        // You can add logic here to store or process the coupon code
      }
      
      // If it's past working hours, automatically select next day
      if (isPastWorkingHours()) {
        let nextDay = addDays(today, 1)
        // Skip Sunday if next day is Sunday
        if (getDay(nextDay) === 0) {
          nextDay = addDays(nextDay, 1)
        }
        selectedDate.value = nextDay
        currentMonth.value = nextDay
      }

      // Existing functionality
      generateDays(currentMonth.value)
      fetchTodayBookingsCount()
      fetchHolidays()
      fetchBookings()
      
      // Scroll to calendar section if coming from a booking link
      const element = document.getElementById('calendar-section')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } catch (error) {
      console.error('Error during component mount:', error)
    }
  })

  // Update the generateTours function
  const generateTours = () => {
    const tourTimes = ['8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM']

    // Generate both types of tours for all time slots
    const allTours = tourTimes.flatMap((time, index) => [
      {
        id: index * 2,
        time,
        type: 'Tour and Tasting',
        isSelected: false,
        guests: null
      },
      {
        id: index * 2 + 1,
        time,
        type: 'Cellar Door Tasting',
        isSelected: false,
        guests: null
      }
    ])

    tours.value = allTours
  }

  // Make sure tours are generated initially
  generateTours()

  const selectTourTime = (time, tourId) => {
    const selectedTour = tours.value.find(tour => tour.id === tourId)
    
    // Track tour selection with Facebook Pixel
    trackSelectTourDateTime({
      tourId: tourId,
      tourType: selectedTour.type,
      date: format(selectedDate.value, 'yyyy-MM-dd'),
      time: time
    });
    
    // Track tour selection with Google Analytics
    if (window.gtag) {
      gtag('event', 'select_tour', {
        event_category: 'Tours',
        event_label: selectedTour.type,
        tour_type: selectedTour.type,  // Custom dimension
        time_slot: time,               // Custom dimension
        tour_id: tourId,
        value: selectedTour.type === 'Tour and Tasting' ? 4000 : 2500
      })
    }

    router.push({
      path: '/tours/confirm',
      query: {
        date: format(selectedDate.value, 'yyyy-MM-dd'),
        time: time,
        tourId: tourId,
        tourType: selectedTour.type
      }
    })
  }

  const upcomingHolidays = computed(() => {
    return holidays.value
      .filter(holiday =>
        !isBefore(parseISO(holiday.date), startOfDay(new Date())) &&
        holiday.actionType !== 'warning' && // Exclude warnings from holiday list
        holiday.actionType !== 'sunday_open' && // Exclude sunday openings from holiday list
        holiday.actionType !== 'schedule_change' && // Exclude schedule changes (day still open)
        (!holiday.blockedTimeSlots || holiday.blockedTimeSlots.length === 0) // Exclude partial-day blocks (day still open)
      )
      .sort((a, b) => parseISO(a.date) - parseISO(b.date))
      .slice(0, 10) // Show only next 10 holidays
  })

  // Add computed property for holiday check (excludes warnings and sunday_open)
  const isSelectedDateHoliday = computed(() => {
    const selectedDateStr = format(selectedDate.value, 'yyyy-MM-dd')
    return holidays.value.some(holiday =>
      holiday.date === selectedDateStr &&
      holiday.actionType !== 'warning' && // Only block if it's not just a warning
      holiday.actionType !== 'sunday_open' && // Sunday opens are not holidays
      holiday.actionType !== 'schedule_change' && // Schedule changes don't close the day
      (!holiday.blockedTimeSlots || holiday.blockedTimeSlots.length === 0) // Partial-day blocks don't close the day
    )
  })

  const todaysOperatingHours = computed(() => {
    const now = new Date()
    const isSaturday = getDay(now) === 6 // Saturday is 6
    if (isSaturday) {
      return '12:00 PM - 6:00 PM'
    }
    return '8:00 AM - 5:00 PM'
  })

  const isOpenToday = computed(() => {
    const now = new Date()
    const todayStr = format(now, 'yyyy-MM-dd')
    const currentHour = now.getHours()
    const currentMinutes = now.getMinutes()
    const currentTime = currentHour + (currentMinutes / 60)

    // Check if it's Sunday or a holiday
    const isSunday = getDay(now) === 0
    const isSaturday = getDay(now) === 6 // Saturday is 6
    // Only consider actual blocking holidays (not warnings or sunday_open)
    const isHoliday = holidays.value.some(holiday =>
      holiday.date === todayStr &&
      holiday.actionType !== 'warning' &&
      holiday.actionType !== 'sunday_open'
    )

    let isWithinBusinessHours = false
    if (isSaturday) {
      // Saturday: 12:00 PM to 6:00 PM (18:00)
      isWithinBusinessHours = currentTime >= 12 && currentTime < 18
    } else {
      // Weekdays: 8:00 AM to 5:00 PM (17:00)
      isWithinBusinessHours = currentTime >= 8 && currentTime < 17
    }

    return !isSunday && !isHoliday && isWithinBusinessHours
  })

  const closedReason = computed(() => {
    const now = new Date()
    const todayStr = format(now, 'yyyy-MM-dd')
    const currentHour = now.getHours()
    const currentMinutes = now.getMinutes()
    const currentTime = currentHour + (currentMinutes / 60)

    const isSundayValue = getDay(now) === 0
    const isSaturdayValue = getDay(now) === 6
    const tomorrow = new Date(now)
    tomorrow.setDate(tomorrow.getDate() + 1)
    const isTomorrowSunday = getDay(tomorrow) === 0
    // Only find actual blocking holidays (not warnings or sunday_open)
    const holiday = holidays.value.find(h =>
      h.date === todayStr &&
      h.actionType !== 'warning' &&
      h.actionType !== 'sunday_open'
    )

    if (isSundayValue) {
      return 'Closed on Sundays\nReopens Monday at 8:00 AM'
    }
    if (holiday) {
      return `Closed for ${holiday.name}\nReopens next business day at 8:00 AM`
    }

    if (isSaturdayValue) {
      if (currentTime < 12) {
        return 'Opens at 12:00 PM today'
      }
      if (currentTime >= 18) { // After 6 PM on Saturday
        return 'Closed for today\nReopens Monday at 8:00 AM' // Assumes Sunday is closed
      }
    } else { // For Mon-Fri
      if (currentTime < 8) {
        return 'Opens at 8:00 AM today'
      }
      if (currentTime >= 17) { // After 5 PM on Mon-Fri
        return isTomorrowSunday
          ? 'Closed for today\nReopens Monday at 8:00 AM'
          : 'Closed for today\nReopens tomorrow at 8:00 AM'
      }
    }
    // Fallback, though ideally all cases are covered above.
    // This would apply if it's within opening hours but isOpenToday is false for some other reason (e.g. holiday check failed temporarily)
    // Or if it's a weekday/Saturday but not explicitly caught by the before/after logic.
    return 'Closed Today\nReopens next business day at 8:00 AM'
  })

  // Add the hardcoded 83 Islands Nights dates
  const islandsNightsDates = [
    '2025-01-31',
    '2025-02-28',
    '2025-03-28',
    '2025-04-25',
    '2025-05-30',
    '2025-06-27',
    '2025-07-25',
    '2025-08-29',
    '2025-09-26',
    '2025-10-31',
    '2025-11-28'
  ]

  // Add custom holiday for September 13th, 2025
  const customHolidays = [
    {
      date: '2025-09-13',
      name: 'Community Event - Closed'
    },
    {
      date: '2025-10-11',
      name: 'Due to a private event, we will be closed to public on Oct 11, 2025'
    }
  ]

  const upcoming83IslandsNights = computed(() => {
    return islandsNightsDates
      .map(date => ({
        date,
        name: '83 Islands Night'
      }))
      .filter(event => !isBefore(parseISO(event.date), startOfDay(new Date())))
      .sort((a, b) => parseISO(a.date) - parseISO(b.date))
  })

  // Computed property to show/hide the September 13th banner
  const showSeptember13Banner = computed(() => {
    const now = new Date()
    const september14th = new Date('2025-09-14')
    return now < september14th
  })

  // Generate structured data for available tour times
  const generateTourStructuredData = () => {
    const baseUrl = 'https://83islands.com'
    const selectedDateStr = format(selectedDate.value, 'yyyy-MM-dd')
    const tourTimes = ['8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM']

    return tourTimes.map((time, index) => {
      const [timeStr, period] = time.split(' ')
      let [hours, minutes] = timeStr.split(':')
      hours = parseInt(hours)
      if (period === 'PM' && hours !== 12) hours += 12
      if (period === 'AM' && hours === 12) hours = 0
      
      const eventDateTime = new Date(selectedDate.value)
      eventDateTime.setHours(hours, parseInt(minutes || 0), 0, 0)
      
      return {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": `83 Islands Distillery Tour - ${time}`,
        "description": "Experience the art of rum making at 83 Islands Distillery. Guided tour through our distillery process followed by a curated tasting of our premium rums.",
        "url": `${baseUrl}/tours`,
        "image": [
          `${baseUrl}/image/83islands_location.jpg`,
          `${baseUrl}/image/productionfloor.jpg`,
          `${baseUrl}/image/rackhouse.jpg`
        ],
        "startDate": eventDateTime.toISOString(),
        "endDate": new Date(eventDateTime.getTime() + 60 * 60 * 1000).toISOString(), // 1 hour duration
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "location": {
          "@type": "Place",
          "name": "83 Islands Distillery",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Port Vila",
            "addressLocality": "Port Vila",
            "addressRegion": "Shefa Province",
            "addressCountry": "VU"
          }
        },
        "organizer": {
          "@type": "Organization",
          "name": "83 Islands Distillery",
          "url": baseUrl
        },
        "offers": [
          {
            "@type": "Offer",
            "name": "Distillery Experience Tour",
            "description": "Guided journey through our artisanal rum-making process",
            "price": "4000",
            "priceCurrency": "VUV",
            "availability": "https://schema.org/InStock",
            "validFrom": selectedDateStr,
            "url": `${baseUrl}/tours`
          },
          {
            "@type": "Offer", 
            "name": "Cellar Door Tasting",
            "description": "Curated tasting of our premium rums",
            "price": "2500",
            "priceCurrency": "VUV",
            "availability": "https://schema.org/InStock",
            "validFrom": selectedDateStr,
            "url": `${baseUrl}/tours`
          }
        ],
        "maximumAttendeeCapacity": 16,
        "remainingAttendeeCapacity": 16
      }
    })
  }
</script>


<style>
/* Optional: Add smooth transition for header */
header {
    transition: transform 0.3s ease;
}

/* Add any additional styles here if needed */
.text-gold {
  color: #F6D993;
}

.bg-gold {
  background-color: #F6D993;
}

html {
  scroll-behavior: smooth;
}
</style>
